// @ts-nocheck: converted from JS
import { _isNotEmpty } from '@/littledash';
import { Nullable } from '@/model/Common.model';

/**
 * Normalizes timepoint values from various formats into a string array.
 * Handles Handsontable's different storage formats (arrays, CSV strings, null/undefined).
 *
 * @param value - The value to convert (array, string, null, undefined, etc.)
 * @returns Array of trimmed string values
 */
export const valueToArray = (value: Nullable<any>): Array<string> => {
  if (Array.isArray(value)) {
    return value.reduce((acc, v) => {
      switch (typeof v) {
        case 'string':
          return [...acc, v.trim()];
        case 'number':
          return [...acc, `${v}`];
        default:
          return acc;
      }
    }, []);
  }
  if (typeof value === 'string') {
    return value.split(',').reduce<Array<string>>((acc, v) => {
      const result = v.trim();
      if (_isNotEmpty(result)) {
        acc.push(result);
      }
      return acc;
    }, []);
  }
  return [];
};

/**
 *
 * @param a
 * @param b
 * @returns {number}
 */
export const sortDesc = (a, b) => b - a;

/**
 *
 * @param a
 * @param b
 * @returns {number}
 */
export const sortAsc = (a, b) => a - b;

/**
 *
 * @param {string} property
 * @returns {function(*, *)}
 */
export const sortDescByProperty = (property) => (a, b) => b[property] - a[property];

/**
 *
 * @param {string} property
 * @returns {function(*, *)}
 */
export const sortAscByProperty = (property) => (a, b) => a[property] - b[property];

/**
 *
 * @param {string} property
 * @returns {function(*, *)}
 */
export const sortDescByDateStrProperty = (property) => (a, b) => new Date(b[property]) - new Date(a[property]);

/**
 *
 * @param {string} property
 * @returns {function(*, *)}
 */
export const sortAscByDateStrProperty = (property) => (a, b) => new Date(a[property]) - new Date(b[property]);

export const getRandomElement = (a: array) => {
  return a[~~(a.length * Math.random())];
};
